export default __webpack_public_path__ + "static/media/765.4818777c.gif";